import {
    EventCategoryAddRequest, EventCategoryDeleteRequest, EventCategoryEditRequest, EventCategoryGetRequest,
} from '@dave/types';
import { createAction, props } from '@ngrx/store';
import { GatewayResponseErrorType } from '../../services/app-gateway.service';
import { EventCategoriesEntity } from '../../entities/event-categories.entity';
import { CategoriesWithAssignments } from '../../services/event-categories.service-data-service';
import { Event2EventCategoriesEntity } from '../../entities/event-to-event-catgories.entity';



const prefix = 'data/' + 'eventCategories/';
export const EventCategoriesActionTypes = {
    Load: createAction(prefix + 'load', props<{ Payload: EventCategoryGetRequest }>()),
    Change: createAction(prefix + 'change', props<{ Payload: EventCategoryEditRequest }>()),
    Delete: createAction(prefix + 'delete', props<{ Payload: EventCategoryDeleteRequest }>()),

    UpdateAll: createAction(prefix + 'updateAll', props<{ Payload: Array<EventCategoriesEntity>; }>()),
    UpdateOne: createAction(prefix + 'updateOne', props<{ Payload: EventCategoriesEntity }>()),
    RemoveOne: createAction(prefix + 'remove', props<{ Payload: string }>()),


    DeleteSuccess: createAction('[Event Categories] Delete Success', props<{ Payload: string }>()),
    UpdateSuccess: createAction('[Event Categories] Update Success', props<{ Payload: EventCategoriesEntity }>()),
    LoadSuccess: createAction ('[EventCategories] Load Success', props<{ Payload: CategoriesWithAssignments }>()),
    CreateRequest: createAction(prefix + 'create/request', props<{ Payload: EventCategoryAddRequest }>()),
    CreateSuccess: createAction(prefix + 'create/success', props<{ Payload: EventCategoriesEntity }>()),
    CreateFailure: createAction(prefix + 'create/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),

    DeleteSuccessE2EC: createAction('[Event Categories] DeleteE2EC Success', props<{ Payload: string }>()),
    CreateSuccessE2EC: createAction(prefix + 'createE2EC/success', props<{ Payload: Event2EventCategoriesEntity }>()),

};
